<template >

<div class="mx-auto" style="margin-bottom:51px !important;
    overflow: scroll;    margin-top: -11px; text-align:justify;">
<v-snackbar bottom  dark color="green darken-2"  v-model="snackbar.show">
        {{ snackbar.message }}
    </v-snackbar>
     <b-modal ref="my-modal" class="text-center" hide-footer title="Are you sure you want to remove this items ?">
      <div class="d-block text-center">
        <h3 style="font-size: 19px;"></h3>
      </div>
      
      <v-row no-gutters style="text-align:center;">

         <!-- <v-col cols="12" sm="6" md="3">
    <b-form-textarea
    size="sm" 
      id="textarea"
      v-model="reason"
      placeholder="Reason for the cancelation"
      rows="3"
      max-rows="6"
    ></b-form-textarea>

   </v-col> -->
            <v-col cols="6"  sm="4" >
               <b-button size="sm" class="mt-2" style="margin-right:5px;" variant="outline-danger" block @click=" hideModal()">Cancel</b-button>
            </v-col>
            
             <v-col cols="6"  sm="4" >
                <b-button size="sm" class="mt-2" style="margin-left:5px;" variant="outline-success" block @click="emptyCart()" >Ok</b-button>
            </v-col>
      </v-row>
     
     
    </b-modal>
 <div v-if="myArray">
   
   <v-list-item class="mx-auto" v-for="(item, i) in myArray" :key="i" >
     
       <v-container fluid class="grey lighten-5 mx-auto" >
    <v-row no-gutters style="    font-size: 13px;">
<!-- 
      <v-col cols="2" >
        <v-card style="border: none;"
          class="pa-2"
          outlined
          tile
        > 
        
         
          

        </v-card>
      </v-col> -->
       <v-col cols="12" >
          
        <v-card
          class="pa-2"
          outlined
          tile
        >
       
         <v-col cols="12" style="font-size: 13px; font-weight:bold;" >
            {{item.ItemName}}
            <br>
            
    <v-row no-gutters style="padding-top:6px;">
      <v-col cols="2" class="text-center">
         <v-list-item-avatar>
           
                <v-img :src="imgURL+item.ItemCode+'.jpg'" :id="item.Barcode"  @error="setAltImg(item.Barcode)" :alt="item.ItemCode+'.jpg'" ></v-img>
               
           
            <!-- <v-img :src="item.Photo"></v-img> -->
          </v-list-item-avatar>
      </v-col>
      <v-col cols="4" class="text-center" style="border: thin solid rgba(0,0,0,.12);">
         Quantity <br>
        <v-card class="pa-2" outlined  style="padding:8px;height:47px border:none !important;">
          
          
        <v-icon size="19" style="background: #ffc107; " id="mini" v-on:click="minus(item.Barcode,item)" >mdi-minus</v-icon>
        <span> <input type="number" :v-model="Qty" :value="item.count" :id="item.Barcode" v-on:change="calc(item.Barcode,item)"   style="padding-left:10px;width:39px;">  
        </span>  
        <v-icon size="19" style="background: #009900;" v-on:click="plus(item.Barcode,item)">mdi-plus</v-icon>
        </v-card>
      </v-col>
         <v-col cols="2" class="text-center" style="border: thin solid rgba(0,0,0,.12);">
            Price <br>
        <v-card class="pa-2" outlined  style="padding:8px;border:none;">
        {{formatPrice(item.SellingRate)}}
        </v-card>
      </v-col>
      <v-col cols="3"   class="text-center" style="border: thin solid rgba(0,0,0,.12);">
         Amount <br>
        <v-card class="pa-2" outlined  style="padding:8px;border:none;" :id="item.Barcode+'bnm'">
         {{formatPrice(item.count * item.SellingRate)}}
        </v-card>

        
      </v-col>
      <v-col cols="1"   class="text-center" style="border: thin solid rgba(0,0,0,.12);">
          <br>
        <v-card class="pa-2" outlined  style="padding:8px;border:none;" >
         <!-- {{formatPrice(item.count * item.SellingRate)}} -->
         <!-- <button @click="del(i)"><v-icon>mdi-delete</v-icon></button> -->
         <v-icon size="15" style="background: #fff; " id="del" v-on:click="del(i)" >mdi-delete</v-icon>
        </v-card>

        
      </v-col>
      
     
      
    </v-row>
           
              
              
           
          </v-col>
         
           
            <!-- <b-form-input v-model="item.count" type="number" placeholder="Enter your name"></b-form-input> -->
         
          
          
        </v-card>
      </v-col>


    </v-row>
  </v-container>
   </v-list-item>

    <v-footer color="primary lighten-1" padless>
    <v-row justify="center" no-gutters>
    <!--   <v-btn v-for="link in links" :key="link" color="white" text rounded class="my-2">
        {{ link }}
      </v-btn> -->
      <v-col class="primary lighten-2 py-4 text-center white--text" cols="12">
        <div class="text-center" >
   <input type="text" id="offer"  placeholder="Enter your promo code"  style="padding: 6px;padding-left:10px;width:200px;border:1px solid #ffc107;align:right">
    <v-btn v-on:click="addOffer()" style="margin-top: -4px;height: 38px;background-color: #ffc107;">  <v-icon>mdi-checkbox-marked-circle</v-icon></v-btn>
    </div>

<!-- //////////////////////////////// -->

<v-container class="grey lighten-5">
    <v-row no-gutters style="align:left" >
      <v-col  cols="4"  sm="4" style="align:left" >
        <v-card class="pa-2" outlined tile  style="align:left" >
          Sub Total <br> <b style="color:#009900;"><span style="color:#000;font-size:10px;">{{currency}}&nbsp;</span>{{formatPrice(totalAmount)}}</b>
        </v-card>
      </v-col>
        
      <v-col  cols="4"  sm="4">
        <v-card class="pa-2" outlined tile >
          Discount({{offerPercentage}}%)<br> <b style="color:#009900;"><span style="color:#000;font-size:10px;">{{currency}}&nbsp;</span>{{formatPrice(discount)}}</b>
        </v-card>
      </v-col>
      <v-col  cols="4 "  sm="4">
        <v-card class="pa-2" outlined tile >
        Total Amount <br> <b style="color:#009900;"><span style="color:#000;font-size:10px;">{{currency}}&nbsp;</span>{{formatPrice(netAmount)}}</b>
        </v-card>
      </v-col>
    </v-row>
     <v-row style="text-align:left,background-color:#fff" no-gutters >
       <v-col cols="8" sm="" class="pa-2 read" outlined tile >
         <v-label>Delivery Charge </v-label>
       </v-col>
       <v-col cols="4" sm="" class="pa-2 read4" outlined tile style="background-color:#fff,line-height: 10.6;">
        <b style="color:#8B0000"><span style="color:#000;font-size:10px;">{{currency}}&nbsp;</span>{{formatPrice(deliveryCharge)}}</b>
       </v-col>
     </v-row>
      <v-row style="text-align:left,background-color:#fff" no-gutters >
       <v-col cols="8" sm="" class="pa-2 read" outlined tile style="background-color:#fff,text-align:right">
         <v-label >Net Amount </v-label>
       </v-col>
       <v-col cols="4" sm="" class="pa-2 read4" outlined tile style="background-color:#fff,line-height: 10.6;">
         <b style="color:#009900;"><span style="color:#000;font-size:10px;">{{currency}}&nbsp;</span>{{formatPrice(deliveryCharge1)}}</b>
       </v-col>
     </v-row>

   
      <div class="text-center pa-5 " style="margin-top: 1em;">
    <v-btn   v-on:click="chekOut()" style="background:#009900; color:#fff;">
      <span>Check Out</span>
      <v-icon> mdi-checkbox-marked</v-icon>
    </v-btn>
  
</div>

 <div class="text-center pa-5 " style="margin-top: 1em;">
    <v-btn   v-on:click="confirmDel()"  style="background:red; color:#fff;">
      <span>Empty Cart</span>
    </v-btn>
  
</div>
  

  </v-container>
<!-- //////////////////////////////////// -->

    </v-col>
    </v-row>
  </v-footer>
   
    
              

     
</div>
<div v-if="!myArray" style="margin-top:10rem"> 
 <div class="text-center text-danger" >Cart is Empty</div>
<div class="text-center " style="margin-top:1rem">
   <v-btn   to="/" style="background:#009900; color:#fff; hight:100%">
      Continue Shopping
    </v-btn>
</div>
</div>
</div>

</template>

<script>
// import Vue from 'vue'
//  import axios from 'axios';
import Router from '../router';
  export default {
    data: () => ({
       currency:'',
       imgURL:'',
      senddata:[],
      OrderDetailsList: [],
      total:'',
      totalarray:[],
      name:'Checkout',
      checkoutItem:[],
      minimum:1,
      Qty:0,
      cartitem:[
        // {"Barcode":"39239090","ItemName":"100 ML (12.5 GM-25 MM)RD CLEAR565/BOX","CurStock":0,"SellingRate":2.9,"Cost":2.9,"Conversion":1,"AltItemNameArabic":"100 مل (12.5 جنرال موتورز-25 ملم)RD CLEAR565/BOX","Photo":"data:image/png;base64,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"}
      ],
       cartlist:[],
       myArray: [],
     offerDetails: [],
    carclicked:[],
    totalAmount:0,
    offerPercentage:0,
    discount:0,
    netAmount:0,
    deliveryCharge:0,
    deliveryCharge1:0,
    totaldelivery:0,
     snackbar: {
                show: false,
                message: null,
                color: null
            },
    }),
    
 
    mounted() {
       this.currency = localStorage.getItem("currency");
       this.imgURL = localStorage.getItem("imgUrl");
      this.offerPercentage=0,
     
      this.deliveryCharge=1,
    this.discount=0,
       this.totalAmount=0;
         this.Amount =0;
          this.netAmount=0;
          this.IsDiscounted=false;
      this.$parent.$children[0].$parent.ttlval = this.name
      //  this.cartitem = this.$parent.$children[0].$parent.addedcartitem
        this.decimalPlaces=localStorage.getItem("decimalPlaces");
       this.myArray = JSON.parse(localStorage.getItem("cartlist"));
       this.$parent.$children[0].$parent.itemcountnumber = localStorage.getItem("cartcount");
       this.checkoutItem = JSON.parse(localStorage.getItem("cartlist"));


       this.IsDiscounted = localStorage.getItem("IsDiscounted");

      

          if(this.myArray!=null || this.myArray !=undefined)
       {
           for(this.i=0;this.i<this.myArray.length;this.i++)
           {

              this.Amount =   (this.myArray[this.i].SellingRate *  this.myArray[this.i].count);
              this.totalAmount += this.Amount ;
          
          }
              this.totalAmount =  this.totalAmount.toFixed(this.decimalPlaces) ;
              this.netAmount = this.totalAmount ;
              this.deliveryCharge1=parseFloat(this.netAmount)+parseFloat(this.deliveryCharge);
              
       }
 if(this.IsDiscounted === "true")
       {
           /*  this.totalAmount = localStorage.getItem("checkoutAmount");
            this.totalAmount =parseFloat(this.totalAmount).toFixed(this.decimalPlaces);
            this.discount = localStorage.getItem("discount");
            this.discount =parseFloat(this.discount);
            this.netAmount = localStorage.getItem("netAmount");
            this.netAmount =parseFloat(this.netAmount);
           this.netAmount += this.discount;
           this.netAmount =this.netAmount.toFixed(this.decimalPlaces);
           this.discount = 0; */
            this.addDiscount()
       }
       
       
      
     
      // this.checkoutItem= this.cartitem;
     
    },
     methods: {
       setAltImg(bar) { 
        this.imgURL = localStorage.getItem("imgUrl");
          this.urlimg = "url("+this.imgURL+"ItemImage.jpg)";
       console.log("aa "+this.urlimg)
         document.getElementById(bar).style.backgroundImage = this.urlimg
         document.getElementById(bar).style.backgroundPosition = "center center";
          document.getElementById(bar).style.backgroundSize = "cover"
       
     }, 
       formatPrice(value) {
        const val = (value/1).toFixed(  this.decimalPlaces);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
  
 del(index) {
    this.IsDiscounted = localStorage.getItem("IsDiscounted");
    if(this.IsDiscounted==="true") 
        {
         this.totalAmount= parseFloat(this.totalAmount)
         this.netAmount= parseFloat(this.netAmount)
         this.discount= parseFloat(this.discount)
           this.netAmount += this.discount;
           this.discount = 0;
        }
   this.myArray = JSON.parse(localStorage.getItem("cartlist"));
      
     this.DeleteCount=this.myArray[index].count;
     this.Rate=this.myArray[index].SellingRate;
     this.DeleteAmount=parseFloat(this.DeleteCount) * parseFloat(this.Rate) ;
     this.totalAmount-=this.DeleteAmount;
     this.totalAmount =  this.totalAmount.toFixed(this.decimalPlaces);
    this.netAmount = this.totalAmount;

     this.carclicked = JSON.parse(localStorage.getItem("carclicked"));
      this.carclicked.splice(index,1); 
      console.log(JSON.stringify(this.carclicked));
      localStorage.setItem("carclicked",JSON.stringify(this.carclicked));
    this.myArray.splice(index,1);
    console.log(this.myArray);
   localStorage.setItem("cartlist", JSON.stringify(this.myArray));
   localStorage.setItem("cartcount",this.myArray.length);
   this.checkoutItem=this.myArray;
   this.$parent.$children[0].$parent.itemcountnumber = this.myArray.length;


   if(this.myArray.length===0)
   {
     this.IsDiscounted=false;
      window.localStorage.removeItem("cartcount");
      window.localStorage.removeItem("cartlist");
      localStorage.setItem("IsDiscounted", this.IsDiscounted);
      this.$parent.$children[0].$parent.itemcountnumber =null;
      location.reload();
   }
   else{
      if(this.IsDiscounted==="true") 
      {
         this.addDiscount()
      }
   }
      location.reload();
      },
      
       
        plus(a,b){
        b.count += 1;
         this.IsDiscounted = localStorage.getItem("IsDiscounted");
        if(this.IsDiscounted==="true") 
        {
           this.netAmount += this.discount;
           this.discount = 0;
        }
        document.getElementById(a).value = b.count;
         document.getElementById(a+"bnm").innerHTML = (b.count * b.SellingRate).toFixed(  this.decimalPlaces);
          this.totalarray.push(b.count * b.SellingRate);
          this.totalAmount=parseFloat(this.totalAmount) + b.SellingRate;
           this.totalAmount =  this.totalAmount.toFixed(this.decimalPlaces);
           this.netAmount = this.totalAmount 
           for( this.i=0;this.i<this.checkoutItem.length; this.i++)
           {
             if(this.checkoutItem[this.i].Barcode===a)
             {
               this.checkoutItem[ this.i].count+=1;
             }
           }
           localStorage.setItem("cartlist", JSON.stringify(this.checkoutItem));
            if(this.IsDiscounted==="true") 
              {
                this.addDiscount();
              }
       },
       calc(a,b){
         this.qwe = document.getElementById(a).value
            this.qwe = parseFloat(this.qwe)
            this.flag =isNaN(this.qwe );
         if(this.qwe<0.100 || this.flag===true)
         {
           document.getElementById(a).value=parseFloat(b.count);
           return;
         }
         else{
             this.IsDiscounted = localStorage.getItem("IsDiscounted");
            if(this.IsDiscounted==true)
            {
                    this.netAmount += this.discount;
                    this.discount = 0;
            }
                       document.getElementById(a).value= this.qwe;
        document.getElementById(a+"bnm").innerHTML = parseFloat( this.qwe * b.SellingRate).toFixed(this.decimalPlaces);
        this.oldtotal = b.count * b.SellingRate;
        this.totalAmount=parseFloat(this.totalAmount)-this.oldtotal;
        this.totalAmount =parseFloat(this.totalAmount) + (parseFloat( this.qwe) * b.SellingRate)
        this.totalAmount =  this.totalAmount.toFixed(this.decimalPlaces);
        this.netAmount = this.totalAmount;
        b.count =parseFloat( this.qwe)
        for(this.i=0;this.i<this.checkoutItem.length;this.i++)
           {
             if(this.checkoutItem[this.i].Barcode===a)
             {
               this.checkoutItem[this.i].count= parseFloat( this.qwe);
             }
           }
           localStorage.setItem("cartlist", JSON.stringify(this.checkoutItem)); 
            if(this.IsDiscounted==="true") 
            {
             this.addDiscount();
            }    
               
           


         
         }
       
       },
       minus(a,b){
          if (b.count > 0.100) {
        b.count -= 1;
        if(b.count < 0.100)
        {
           document.getElementById(a).innerHTML = 1;
          b.count+=1; 
          return;
        }else{

           this.IsDiscounted = localStorage.getItem("IsDiscounted");
        if(this.IsDiscounted==="true") 
        {
           this.netAmount += this.discount;
           this.discount = 0;
        }
           document.getElementById(a).value = b.count;
        document.getElementById(a+"bnm").innerHTML = (b.count * b.SellingRate).toFixed(  this.decimalPlaces);
        this.totalarray.push(b.count * b.SellingRate);
        this.totalAmount= parseFloat(this.totalAmount) - b.SellingRate;
         this.totalAmount =  this.totalAmount.toFixed(  this.decimalPlaces);
         this.netAmount = this.totalAmount 
        for( this.i=0;this.i<this.checkoutItem.length; this.i++)
           {
             if(this.checkoutItem[this.i].Barcode===a)
             {
               this.checkoutItem[ this.i].count-=1
             }
           }
           localStorage.setItem("cartlist", JSON.stringify(this.checkoutItem));
           localStorage.setItem("IsDiscounted", this.IsDiscounted);

            if(this.IsDiscounted==="true") 
              {
                this.addDiscount();
              }
        }
        //  document.getElementById("mini").style.visibility="inherit" ;
       
        
      }
       },
       chekOut()
       { 
         this.$parent.$children[0].$parent.checkout = this.checkoutItem;
          console.log(this.checkoutItem.length);

         for(this.i=0;this.i<this.checkoutItem.length;this.i++)
         {
           this.obj={
            
            "AltUnitId": 179553,
            "Quantity": 2.0,
            "Rate": 2.8,
            "TaxAmount": 0.4

                }
          this.obj.AltUnitId = this.checkoutItem[this.i].AltUnitId
          this.obj.Quantity = this.checkoutItem[this.i].count
          this.obj.Rate = this.checkoutItem[this.i].SellingRate
          this.obj.TaxAmount = (this.checkoutItem[this.i].SellingRate - this.checkoutItem[this.i].DiscRateB4Tax) * this.checkoutItem[this.i].count
           
           this.OrderDetailsList.push(this.obj)
            // console.log(this.obj);
           
          
         }

         this.objj={

    "SalesMan": "",
    "CustomerId": 1,
    "DeliveryDate": "2020-06-13T00:00:00",
    "Remarks": "remark test",
    "DeliveryCharge": 1.0,
    "Discount": 0.2,
    "PromoCode": "EID",
    "OrderDetailsList":this.OrderDetailsList

         }

         this.senddata.push(this.objj)



         if(this.senddata)
         {
          
  //         axios.post('https:sample-endpoint.com/user', {
  //   Name: 'Fred',
  //   Age: '23'
  // })
  // .then(function (response) {
  //   console.log(response);
  // })
      localStorage.setItem("sendatta",JSON.stringify(this.senddata));
      // axios.post(this.$bURL+"OnlineOrder",this.senddata)
      // .then((response)  =>  {
      //  console.log(response.data)
          
      // }, (error)  =>  {
      //     console.log(error)
      // })

    
         }

            


          
          // window.localStorage.removeItem("cartlistarray");
          //  window.localStorage.removeItem("cartlist");
          //  window.localStorage.removeItem("cartcount");
           Router.push('/Customer');
       },
        
       addDiscount()
       {
            console.log("hited")
            this.amt=0;
          this.checkoutAmount=0;
         for(this.i=0;this.i<this.checkoutItem.length;this.i++)
         {
          this.amt =this.checkoutItem[this.i].count * this.checkoutItem[this.i].SellingRate;
          this.checkoutAmount+=this.amt;
         }
          this.IsDiscounted = localStorage.getItem("IsDiscounted");
        if(this.IsDiscounted==="true")
        {
            this.offerName = localStorage.getItem("offerName");
        }else{
            this.offerName = document.getElementById('offer').value;
        }
          
         for(this.i=0;this.i<this.offerDetails.length;this.i++)
         {
           if(this.offerDetails[this.i].Offer===this.offerName)
           {
             this.offerPercentage = this.offerDetails[this.i].Percentage;
             this.discount =  (this.checkoutAmount* this.offerPercentage)/100;
             this.discount =  this.discount.toFixed(this.decimalPlaces);
             this.netAmount =(this.totalAmount )- this.discount;
             this.netAmount= this.netAmount.toFixed(this.decimalPlaces);
             this.deliveryCharge1=parseFloat(this.netAmount)+parseFloat(this.deliveryCharge);
             
             this.IsDiscounted=true;



             localStorage.setItem("IsDiscounted", this.IsDiscounted);
             localStorage.setItem("offerName", this.offerName);
               this.checkoutAmount = this.checkoutAmount.toFixed(  this.decimalPlaces)
              localStorage.setItem("checkoutAmount", this.checkoutAmount);
               localStorage.setItem("discount", this.discount);
               localStorage.setItem("offerPercentage", this.offerPercentage);
                localStorage.setItem("netAmount", this.netAmount);
             break;
           }
         }

       },
       addOffer()
       {
          this.IsDiscounted = localStorage.getItem("IsDiscounted");
          if(this.IsDiscounted=="true")
          {
            return;
          }
          else
            {
              this.addDiscount();
            }
       },
        confirmDel()
      {
        // localStorage.setItem("delpos",del);
        // localStorage.setItem("orderId",orderId);
       
        this.$refs['my-modal'].show()
         
        
    
      },
      hideModal() {
        this.$refs['my-modal'].hide()
       },
emptyCart()
{
window.localStorage.removeItem("carclicked");
  window.localStorage.removeItem("cartcount");
      window.localStorage.removeItem("cartlist");
      this.IsDiscounted=false;
      localStorage.setItem("IsDiscounted", this.IsDiscounted);
      location.reload();
}
      
    }
    
    
  }
</script>
<style >
.v-list-item
{
  padding-left: 0px;
    padding-right: 0px;
}
.text-danger {
    color: #dc3545 !important;
    font-size: 20px;
}
 .read {
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
    background-color: #FFF;
    text-align: left;
    border: thin solid rgba(0,0,0,.12);
}
/* .read4 {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
    padding-top: 12px;
    padding-bottom: 12px;
    border: thin solid rgba(0,0,0,.12);
} */
.theme--light.v-label {
    color: #222;
     padding-top: 12px; 
    padding-bottom: 12px;
    padding-left: 24px;
    
}
.read4 {
     
     /* padding-top: 15px;  */
    padding-bottom: 12px;
    background-color: #fff;
    border: thin solid rgba(0,0,0,.12);

}  
.theme--light.v-label {
    
    padding-top: 3px; 
    padding-bottom: 6px;
    padding-left: 24px;
}
/* .theme--light.v-card.v-card--outlined {
   border: none; 
} */
</style>